import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as api from '../api/client';

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    (async () => {
      const [davetiyeler, sekerlik, digital] = await Promise.all([
        api.getProducts('davetiyeler'),
        api.getProducts('sekerlik'),
        api.getDigitalInvitations(),
      ]);
      setStats({
        davetiyeler: davetiyeler.length,
        sekerlik: sekerlik.length,
        digital: digital.length,
        publishedDigital: digital.filter((d) => d.published).length,
      });
    })();
  }, []);

  return (
    <>
      <header className="admin-header">
        <h2>Dashboard</h2>
        <p>Site içeriğinize genel bakış</p>
      </header>

      <div className="admin-content">
        {stats && (
          <div className="admin-stats">
            <div className="admin-stat">
              <div className="admin-stat__label">Davetiye ürünü</div>
              <div className="admin-stat__value">{stats.davetiyeler}</div>
            </div>
            <div className="admin-stat">
              <div className="admin-stat__label">Şekerlik ürünü</div>
              <div className="admin-stat__value">{stats.sekerlik}</div>
            </div>
            <div className="admin-stat">
              <div className="admin-stat__label">Dijital davetiye</div>
              <div className="admin-stat__value">{stats.digital}</div>
            </div>
            <div className="admin-stat">
              <div className="admin-stat__label">Yayında dijital</div>
              <div className="admin-stat__value">{stats.publishedDigital}</div>
            </div>
          </div>
        )}

        <div className="admin-card">
          <h3 className="admin-section-title">Hızlı işlemler</h3>
          <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
            <Link to="/admin/products/davetiyeler" className="admin-btn admin-btn--secondary">
              Davetiye ekle
            </Link>
            <Link to="/admin/digital-invitations/new" className="admin-btn admin-btn--primary">
              Dijital davetiye oluştur
            </Link>
            <Link to="/admin/settings" className="admin-btn admin-btn--secondary">
              Ayarları düzenle
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
